import { apiGetInvitations } from '../../common/api/invitations'

const fetchArchivedInvitations = (params = {}) => ({
  requestPrefix: 'ARCHIVED_INVITATIONS:FETCH',
  request: () =>
    apiGetInvitations({
      scope: 'archived',
      include: `assessment_file_invitation.details,assessment_file_invitation.invited_by,assessment_file_invitation.account.names,assessment_file_invitation.guest_moderator,assessment_file_invitation.account.names,assessment_file_invitation.timestamps,assessment_file_invitation.assessment_file,assessment_file_invitation.assessment_file.details,collection.order.desc,collection.limit.10,collection.page.${params.page ||
        1}`
    })
})

export { fetchArchivedInvitations }
